import API from "../constants/api";
import axiosInstance, { axiosException } from "./axios";

export const loginRequest = async (email, password) => {
  try {
    const response = await axiosInstance.post(API.LOG_IN, { email, password });
    return {
      success: true,
      data: response.data,
      message: "success",
    };
  } catch (e) {
    return axiosException(e);
  }
};

export const adminLoginRequest = async (login_code, admin_password) => {
  try {
    const response = await axiosInstance.post(API.ADMIN_LOG_IN, { login_code, admin_password });
    return {
      success: true,
      data: response.data,
      message: "success",
    };
  } catch (e) {
    return axiosException(e);
  }
};

export const forgotPasswordRequest = async (email) => {
  try {
    const response = await axiosInstance.post(API.FORGOT_PASSWORD, {
      email,
      role: "company",
    });
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const getProfileRequest = async () => {
  try {
    const response = await axiosInstance.get(API.PROFILE);
    return response.data.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const updateProfileRequest = async (formData) => {
  try {
    const response = await axiosInstance.post(API.PROFILE, formData);
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const getMasterProfileRequest = async () => {
  try {
    const response = await axiosInstance.get(API.MASTER_PROFILE);
    return response.data.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const getAuthenticationDetailForInvitation = async () => {
  try {
    const response = await axiosInstance.get(API.INVITATION);
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const getQuote = async (data) => {
  try {
    const response = await axiosInstance.post(API.GET_QUOTE, data);
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const upgradePlan = async (data) => {
  try {
    const response = await axiosInstance.post(API.UPGRADE_PLAN, data);
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};
